<template>
  <div id="m-mobile-f">
    <p class="c-line"></p>
    <p class="p1">浙江科友信息工程股份有限公司</p>
    <p class="p3">电话：0579-85572572</p>
    <p class="p4">邮箱：keyou@zjkeyou.com</p>
    <p class="p2">地址：义乌市雪峰西路968号义乌科技创业园
      科技大楼A座9楼</p>
    <div class="d1">
      <img src="../../../assets/57.jpg"/>
      <p>关注科友微信公众号</p>
    </div>
    <div class="d2">
      Copyright 2017-2021 ©
      <br/>
      Keyougufen All Rights Reserved
    </div>
  </div>
</template>

<script>
  export default {
    name: "mfooter",
    data(){
      return{
      }
    },
    mounted(){
    },
    methods: {
    },
  }
</script>

<style>
  #m-mobile-f {
    background-color: #373A5A;
    padding: 3.44rem 5.6rem 3.41rem 1.88rem;
  }
  #m-mobile-f .c-line {
    width: 1.25rem;
    height: 0.13rem;
    background: #89B929;
    margin-bottom: 0.8rem;
  }
  #m-mobile-f .p1 {
    height: 0.97rem;
    font-size: 1rem;
    font-weight: 400;
    color: #FFFFFF;
    line-height: 0.94rem;
    margin-bottom: 0.8rem;
  }
  #m-mobile-f .p2 {
    /*height: 1.88rem;*/
    font-size: 0.75rem;
    font-weight: 300;
    color: #FFFFFF;
    line-height: 1.13rem;
    margin-bottom: 2rem;
  }
  #m-mobile-f .p3 , #m-mobile-f .p4 {
    /*height: 1.91rem;*/
    font-size: 0.75rem;
    font-weight: 300;
    color: #FFFFFF;
    line-height: 1.13rem;
  }
  #m-mobile-f .p4 {
    /*margin-bottom: 2.5rem;*/
  }
  #m-mobile-f .d1 {
    width: 7.8rem;
}
  #m-mobile-f .d1 img{
    width: 100%;
  }
  #m-mobile-f .d1 p {
    height: 0.8rem;
    font-size: 0.75rem;
    font-weight: 300;
    color: #9497B0;
    line-height: 0.94rem;
    text-align: center;
    margin-top: 0.6rem;
    margin-bottom: 3.7rem;
  }
  #m-mobile-f .d2 {
    font-size: 0.63rem;
    font-weight: 300;
    color: #9497B0;
    line-height: 0.94rem;
  }
</style>



// WEBPACK FOOTER //
// src/components/Mobile/common/footer.vue